import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, IconButton, Modal, Typography } from '@mui/material';
import '../styles.css';
import { sxTermsOfUseModal, sxTermsOfUseModalTitle } from '../sxProps';
import DefaultButton from '../../../../components/Accessibility/DefaultButton';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import DefaultCheckbox from '../../../../components/Accessibility/DefaultCheckbox';
import DefaultText from '../../../../components/Accessibility/DefaultText';
import { getTermoSaudeEmocional, postAceiteSaudeEmocional } from '../../../../services/SaudeBemEstar/SaudeEmocionalService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { sxButton } from '../../UnimedAcolhe/sxProps';
import '../styles.css'

interface Props {
	open: boolean;
    onTermoAceito: () => void;
    onClose: () => void;
}

function TermoDeUsoModal(props: Props) {

    const [agreed, setAgreed] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [loadingAceite, setLoadingAceite] = useState<boolean>(false);
    const [content, setContent] = useState<string>('');
    const [termo, setTermo] = useState<string>('');

    useEffect(() => {
        setLoading(true);
        getTermoSaudeEmocional()
            .then(response => {
                setContent(response?.descricao);
                setTermo(response?.idTermoResponsabilidade)
            })
            .catch(console.log)
            .finally(() => {
                setLoading(false);
            })
    }, []);

    const { 
        fontSizeStyleAccessibility, 
        contrastStyle, 
        contrastMode,
        textStyleAccessibility,
        contrastBorderAccessibility } = useAccessibility();

    const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAgreed(event.target.checked);
    };

    const continuar = () => {
        setLoadingAceite(true);
        postAceiteSaudeEmocional(parseInt(termo), true)
            .then(_ => {
                props.onTermoAceito();
            })
            .catch(console.log)
            .finally(() => {
                setLoadingAceite(false);
            })
    }

    return (
        <div>
            <Modal
                open={props.open}
                onClose={props.onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={sxTermsOfUseModal} style={{ ...contrastStyle, ...contrastBorderAccessibility}}>
                    <div className="terms-of-use-holder">
                        <IconButton
                            aria-label="close"
                            onClick={props.onClose}
                            sx={{
                                position: 'absolute',
                                right: 20,
                                top: 20,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <FontAwesomeIcon className='icon-close-modal' icon={faTimes} />
                        </IconButton>
                        <Typography sx={sxTermsOfUseModalTitle} style={textStyleAccessibility}>
                            Termos de Uso
                        </Typography>
                        {
                            loading
                            ? <CircularProgress />
                            : <div className='termos-de-uso-auto-avaliacao-container' style={{ ...contrastStyle, ...contrastBorderAccessibility}}>
                                <div 
                                    className={`termos-de-uso-auto-avaliacao-descricao ${contrastMode ? 'contrast' : ''}`}
                                    style={fontSizeStyleAccessibility} 
                                    dangerouslySetInnerHTML={{ __html: content }}
                                    tabIndex={0} />
                            </div>
                        }
                        
                        <div className='flex-row'>
                            <DefaultCheckbox onChange={handleCheck}/>
                            <DefaultText text="Eu li e concordo com os Termos de Uso da Telessaúde" />
                        </div>
                        <div className='container-btn'>
                            <div className='terms-of-use-btn'>
                                <DefaultButton
                                    onClick={props.onClose}
                                    sx={sxButton}
                                    text={'Cancelar'}
                                    variant={'outlined'}
                                    fullWidth
                                />
                            </div>
                            <div >
                                {
                                    loadingAceite
                                    ? <CircularProgress />
                                    : <DefaultButton disabled={!agreed} onClick={continuar} text="Confirmar" fullWidth/>
                                }
                            </div>
                        </div>
                    </div>
                </Box>
            </Modal>
        </div>
    )
}

export default TermoDeUsoModal;